export const css = {
    root: '_10Ov9sFs',
    heading: '_4DPiBtay',
    relatedItems: '_1Asfqz_5',
    ' _key': 'related-topics/related-topics'
};
export default css;
